var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.clickAction)?_c('span',{class:_vm.$s.ActionNavLink,on:{"click":_vm.clickAction}},[_vm._t("default")],2):(_vm.shouldUseNuxtLink)?_c('nuxt-link',{class:_vm.$s.NavLink,attrs:{"to":_vm.href}},[_vm._t("default")],2):_c('a',{class:_vm.$s.NavLink,attrs:{"href":_vm.href}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }